<template>
  <section :class="{'first-level':currentLevel==1 && $route.params.grade_id== 2 || $route.params.grade_id==5 , 'first-level-1-2':currentLevel==1 && $route.params.grade_id== 9 || $route.params.grade_id==55 , 'subjects': currentLevel>=2 && currentLevel<=3,'fourth-level':currentLevel==4 }">
    <div class="row my-4">
      <div class="description col-sm-12">
        <div></div>
        <h1 class="text-uppercase text-white">{{ $t('clusterC.chooseSubject') }}</h1>
      </div>
    </div>
    <div class="row-subject">
      <div v-for="subject in subjects" :key="subject.id">
        <div v-if="currentLevel<=3">
                 <router-link
          :to="{
            name: 'subject',
            params: { subject_id: subject.id, grade_id: $route.params.grade_id },
          }"
          :class="{'first-level__subject':currentLevel==1&& $route.params.grade_id== 2 || $route.params.grade_id==5 ,'first-level-1-2__subject':currentLevel==1 && $route.params.grade_id== 9 || $route.params.grade_id==55 , 'subjects__subject': currentLevel>=2 && currentLevel<=3 }"
          @click.native="$store.commit('subject/SET_CURRENT_SUBJECT', subject)"
        >
          <!-- icon -->
          <div :class="{'first-level__subject__icon':currentLevel==1 && $route.params.grade_id== 2 || $route.params.grade_id==5 ,'first-level-1-2__subject__icon':currentLevel==1 && $route.params.grade_id== 9 || $route.params.grade_id==55, 'subjects__subject__icon':currentLevel>=2 && currentLevel<=3 }">
            <img :src="subject.icon" class="subject-logo" />
            <!--<img src="@/assets/images/math-3-en.png" class="subject-logo" alt="">-->
          </div>
          <!-- info -->
          <div :class="{'first-level__subject__body':currentLevel==1 && $route.params.grade_id== 2 || $route.params.grade_id==5 ,'first-level-1-2__subject__body':currentLevel==1 && $route.params.grade_id== 9 || $route.params.grade_id==55,'subjects__subject__body': currentLevel>=2 && currentLevel<=3 }">
            <h4 class="lesson-title">
              {{ subject.name.find(item => item.lang === lang).value | deleteNumbers }}
            </h4>
            <!-- <p v-if="$route.params.grade_id != 5 && $route.params.grade_id != 2" class="subject-progress"> -->
              <div class="progress">
                <p class="progress-leyend">   {{ subject.completed_lessons }} {{ $t('clusterC.of') }} {{ subject.total_lessons }}</p>
                <div class="progress-bar" :style="'width:'+ getPercent( subject.completed_lessons,subject.total_lessons )" role="progressbar" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                <!--only visible for level 1-->
                <span class="start" v-if="currentLevel==1">
                  <img src="~@/assets/estrella_barra.svg" alt="">
                </span>
                <span class="start" v-if="currentLevel==3">
                  <img src="~@/assets/icons/middleSchool/Barra_3.svg" alt="">
                </span>
                <span class="start" v-if="currentLevel==4">
                  <img src="~@/assets/icons/highSchool/Barra_2.svg" alt="">
                </span>
              </div>
            <p class="lesson-progress">
              {{ subject.completed_lessons }} {{ $t('clusterC.of') }} {{ subject.total_lessons }}
              {{ $t('clusterC.completed') }}
              {{
                (subject.progress_percent = (subject.completed_lessons * 100) / subject.total_lessons) | percentage(2)
              }}
            </p>
          </div>
        </router-link>
        </div>
        <div v-else>
          <router-link
            :to="{
              name: 'subject',
              params: { subject_id: subject.id, grade_id: $route.params.grade_id },
            }"
            :class="{'fourth-level__subject':currentLevel==4 }"
            @click.native="$store.commit('subject/SET_CURRENT_SUBJECT', subject)"
            >
            <!-- info -->
            <div :class="{'fourth-level__subject__body': currentLevel==4}">
              <h4 class="lesson-title">
                {{ subject.name.find(item => item.lang === lang).value | deleteNumbers }}
              </h4>
                  <!-- icon -->
              <div :class="{'icon':currentLevel==4}">
                <img :src="subject.icon" class="subject-logo" />
                <!--<img src="@/assets/images/math-3-en.png" class="subject-logo" alt="">-->
              </div>
              <p class="lesson-progress">
                {{ subject.completed_lessons }} {{ $t('clusterC.of') }} {{ subject.total_lessons }}
                {{ $t('clusterC.completed') }}
                {{
                  (subject.progress_percent = (subject.completed_lessons * 100) / subject.total_lessons) | percentage(2)
                }}
              </p>
              <!-- <p v-if="$route.params.grade_id != 5 && $route.params.grade_id != 2" class="subject-progress"> -->
              <div class="progress">
                <p class="progress-leyend">   {{ subject.completed_lessons }} {{ $t('clusterC.of') }} {{ subject.total_lessons }}</p>
                <div class="progress-bar" :style="'width:'+ getPercent( subject.completed_lessons,subject.total_lessons )" role="progressbar" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                <span class="start" v-if="currentLevel==4">
                  <img src="~@/assets/icons/highSchool/Barra_2.svg" alt="">
                </span>
              </div>       
            </div>      
        </router-link>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'lessonCards',
  data() {
    return {
      completed: '',
      inProgress: '',
      lessonTotal: '',
      level:null,
    };
  },
  computed: {
    ...mapGetters({
      subjects: 'subject/list',
      userAuthenticated: 'userAuthenticated',
      currentGrade: 'currentGrade',
      currentLevel: 'getCurrentLevel',
      lang: 'app/language',
    }),
  },
  created() {
    this.onFetchSubjects();
    console.log('current Level', this.currentLevel);
    //change backgroundColor trow meta of router
    if(this.currentLevel==1){
      this.$route.meta.backgroundColor='blue'
    }
    if(this.currentLevel==2){
      this.$route.meta.backgroundColor='orange'
    }
    if(this.currentLevel==3){
      this.$route.meta.backgroundColor='newOrange'
    }
    if(this.currentLevel==4){
      this.$route.meta.backgroundColor='darkBlue'
    }
  },
  updated(){
    // change icon images for pk, k
    if ((this.$route.params.grade_id==2 && this.level==1) || (this.$route.params.grade_id==5 && this.level==1)){
      for (let index = 0; index < this.subjects.length; index++) {
        const element = this.subjects[index];
        switch (index) {
          case 0:
            element['icon']=`${require("../../assets/icons/subjects/icono_arts_language.svg")}`;
            break;
          case 1:
            element['icon']=`${require("../../assets/icons/subjects/icono_math.svg")}`;
            break;
          case 2:
            element['icon']=`${require("../../assets/icons/subjects/icono_science.svg")}`;
            break;
          case 3:
            element['icon']=`${require("../../assets/icons/subjects/icono_social_studies.svg")}`;
            break;
          default:
            break;
        }
      }
    }
      // change icon images for grades (1)
    if ((this.$route.params.grade_id==9 && this.level==1) ){
      for (let index = 0; index < this.subjects.length; index++) {
        const element = this.subjects[index];
        switch (index) {
          case 0:
            element['icon']=`${require("../../assets/icons/lowerElementarySchool/iconos_grado_1/Icon12_math.svg")}`;
            break;
          case 1:
            element['icon']=`${require("../../assets/icons/lowerElementarySchool/iconos_grado_1/Icon12_05.svg")}`;
            break;
          case 2:
            element['icon']=`${require("../../assets/icons/lowerElementarySchool/iconos_grado_1/Icon12_07.svg")}`;
            break;
          case 3:
            element['icon']=`${require("../../assets/icons/lowerElementarySchool/iconos_grado_1/Icon12_08.svg")}`;
            break;
          case 4:
            element['icon']=`${require("../../assets/icons/lowerElementarySchool/iconos_grado_1/Icon12_06.svg")}`;
            break;
          case 5:
            element['icon']=`${require("../../assets/icons/lowerElementarySchool/iconos_grado_1/Icon12_09.svg")}`;
            break;
          default:
            break;
        }
      }
     }
      // change icon images for grades (2)
    if ((this.$route.params.grade_id==55 && this.level==1) ){
      for (let index = 0; index < this.subjects.length; index++) {
        const element = this.subjects[index];
        switch (index) {
          case 0:
            element['icon']=`${require("../../assets/icons/lowerElementarySchool/iconos_grado_2/Icon12-10.svg")}`;
            break;
          case 1:
            element['icon']=`${require("../../assets/icons/lowerElementarySchool/iconos_grado_2/Icon12-15.svg")}`;
            break;
          case 2:
            element['icon']=`${require("../../assets/icons/lowerElementarySchool/iconos_grado_2/Icon12-13.svg")}`;
            break;
          case 3:
            element['icon']=`${require("../../assets/icons/lowerElementarySchool/iconos_grado_2/Icon12-14.svg")}`;
            break;
          case 4:
            element['icon']=`${require("../../assets/icons/lowerElementarySchool/iconos_grado_2/Icon12-12.svg")}`;
            break;
          case 5:
            element['icon']=`${require("../../assets/icons/lowerElementarySchool/iconos_grado_2/Icon12-11.svg")}`;
            break;
          default:
            break;
        }
      }
     }
     //change icon images for level 2 -> grades(3)
    if((this.$route.params.grade_id==109 && this.level==2)){
       for (let index = 0; index < this.subjects.length; index++) {
        const element = this.subjects[index];
        switch (index) {
          case 0:
            element['icon']=`${require("../../assets/icons/upperElementarySchool/iconos_grado_3/math_3.svg")}`;
            break;
          case 1:
            element['icon']=`${require("../../assets/icons/upperElementarySchool/iconos_grado_3/Grammar_3.svg")}`;
            break;
          case 2:
            element['icon']=`${require("../../assets/icons/upperElementarySchool/iconos_grado_3/Reading_3.svg")}`;
            break;
          case 3:
            element['icon']=`${require("../../assets/icons/upperElementarySchool/iconos_grado_3/Science_3.svg")}`;
            break;
          case 4:
            element['icon']=`${require("../../assets/icons/upperElementarySchool/iconos_grado_3/Social_Studies_3.svg")}`;
            break;
          case 5:
            element['icon']=`${require("../../assets/icons/upperElementarySchool/iconos_grado_3/Vocabulary_3.svg")}`;
            break;
          default:
            break;
        }
      }
    }
    //change icon images for level 2 -> grades(4)
    if((this.$route.params.grade_id==157 && this.level==2)){
       for (let index = 0; index < this.subjects.length; index++) {
        const element = this.subjects[index];
        switch (index) {
          case 0:
            element['icon']=`${require("../../assets/icons/upperElementarySchool/iconos_grado_4/Math_4.svg")}`;
            break;
          case 1:
            element['icon']=`${require("../../assets/icons/upperElementarySchool/iconos_grado_4/Grammar_4.svg")}`;
            break;
          case 2:
            element['icon']=`${require("../../assets/icons/upperElementarySchool/iconos_grado_4/Reading_4.svg")}`;
            break;
          case 3:
            element['icon']=`${require("../../assets/icons/upperElementarySchool/iconos_grado_4/Science_4.svg")}`;
            break;
          case 4:
            element['icon']=`${require("../../assets/icons/upperElementarySchool/iconos_grado_4/Social_studies_4.svg")}`;
            break;
          case 5:
            element['icon']=`${require("../../assets/icons/upperElementarySchool/iconos_grado_4/Vocabulary_4.svg")}`;
            break;
          default:
            break;
        }
      }
    }
    //change icon images for level 2 -> grades(5)
    if((this.$route.params.grade_id==200 && this.level==2)){
       for (let index = 0; index < this.subjects.length; index++) {
        const element = this.subjects[index];
        switch (index) {
          case 0:
            element['icon']=`${require("../../assets/icons/upperElementarySchool/iconos_grado_5/Math_5.svg")}`;
            break;
          case 1:
            element['icon']=`${require("../../assets/icons/upperElementarySchool/iconos_grado_5/Grammar_5.svg")}`;
            break;
          case 2:
            element['icon']=`${require("../../assets/icons/upperElementarySchool/iconos_grado_5/Reading_5.svg")}`;
            break;
          case 3:
            element['icon']=`${require("../../assets/icons/upperElementarySchool/iconos_grado_5/Science_5.svg")}`;
            break;
          case 4:
            element['icon']=`${require("../../assets/icons/upperElementarySchool/iconos_grado_5/Social_studies_5.svg")}`;
            break;
          case 5:
            element['icon']=`${require("../../assets/icons/upperElementarySchool/iconos_grado_5/Vocabulary_5.svg")}`;
            break;
          default:
            break;
        }
      }
    }
     //change icon images for level 3 -> grades(6)
    if((this.$route.params.grade_id==250 && this.level==3)){
         for (let index = 0; index < this.subjects.length; index++) {
        const element = this.subjects[index];
        switch (index) {
          case 0:
            element['icon']=`${require("../../assets/icons/middleSchool/Iconos_grado_6/Math_6.svg")}`;
            break;
          case 1:
            element['icon']=`${require("../../assets/icons/middleSchool/Iconos_grado_6/Grammar_6.svg")}`;
            break;
          case 2:
            element['icon']=`${require("../../assets/icons/middleSchool/Iconos_grado_6/Reading_6.svg")}`;
            break;
          case 3:
            element['icon']=`${require("../../assets/icons/middleSchool/Iconos_grado_6/Science_6.svg")}`;
            break;
          case 4:
            element['icon']=`${require("../../assets/icons/middleSchool/Iconos_grado_6/Social_Studies_6.svg")}`;
            break;
          case 5:
            element['icon']=`${require("../../assets/icons/middleSchool/Iconos_grado_6/Vocabulary_6.svg")}`;
            break;
          default:
            break;
        }
      }
    }
    //change icon images for level 3 -> grades(7)
    if((this.$route.params.grade_id==300 && this.level==3)){
         for (let index = 0; index < this.subjects.length; index++) {
        const element = this.subjects[index];
        switch (index) {
          case 0:
            element['icon']=`${require("../../assets/icons/middleSchool/Iconos_grado_7/Math_7.svg")}`;
            break;
          case 1:
            element['icon']=`${require("../../assets/icons/middleSchool/Iconos_grado_7/Grammar_7.svg")}`;
            break;
          case 2:
            element['icon']=`${require("../../assets/icons/middleSchool/Iconos_grado_7/Reading_7.svg")}`;
            break;
          case 3:
            element['icon']=`${require("../../assets/icons/middleSchool/Iconos_grado_7/Science_7.svg")}`;
            break;
          case 4:
            element['icon']=`${require("../../assets/icons/middleSchool/Iconos_grado_7/Social_studies_7.svg")}`;
            break;
          case 5:
            element['icon']=`${require("../../assets/icons/middleSchool/Iconos_grado_7/Vocabulary_7.svg")}`;
            break;
          default:
            break;
        }
      }
    }
    //change icon images for level 3 -> grades(8)
    if((this.$route.params.grade_id==349 && this.level==3)){
         for (let index = 0; index < this.subjects.length; index++) {
        const element = this.subjects[index];
        switch (index) {
          case 0:
            element['icon']=`${require("../../assets/icons/middleSchool/Iconos_grado_8/Math_8.svg")}`;
            break;
          case 1:
            element['icon']=`${require("../../assets/icons/middleSchool/Iconos_grado_8/Grammar_8.svg")}`;
            break;
          case 2:
            element['icon']=`${require("../../assets/icons/middleSchool/Iconos_grado_8/Reading_8.svg")}`;
            break;
          case 3:
            element['icon']=`${require("../../assets/icons/middleSchool/Iconos_grado_8/Science_8.svg")}`;
            break;
          case 4:
            element['icon']=`${require("../../assets/icons/middleSchool/Iconos_grado_8/Social_studies_8.svg")}`;
            break;
          case 5:
            element['icon']=`${require("../../assets/icons/middleSchool/Iconos_grado_8/Vocabulary_8.svg")}`;
            break;
          default:
            break;
        }
      }
    }
    //change icon images for level 4 -> grades(9,10,11)
    if(this.level==4){
       for (let index = 0; index < this.subjects.length; index++) {
        const element = this.subjects[index];
        switch (index) {
          case 0:
            element['icon']=`${require("../../assets/icons/highSchool/U_S_studies.svg")}`;
            element['name'][0]['value']="U. S. History";
            element['name'][1]['value']="Historia U. S.";
            break;
          case 1:
            element['icon']=`${require("../../assets/icons/highSchool/physics.svg")}`;
            break;
          case 2:
            element['icon']=`${require("../../assets/icons/highSchool/World_studies.svg")}`;
            break;
          case 3:
            element['icon']=`${require("../../assets/icons/highSchool/Biology.svg")}`;
            break;
          case 4:
            element['icon']=`${require("../../assets/icons/highSchool/Chemistry.svg")}`;
            break;
          case 5:
            element['icon']=`${require("../../assets/icons/highSchool/English_1.svg")}`;
            break;
          case 6:
            element['icon']=`${require("../../assets/icons/highSchool/English_2.svg")}`;
            break;
          case 7:
            element['icon']=`${require("../../assets/icons/highSchool/English_3.svg")}`;
            break;
          case 8:
            element['icon']=`${require("../../assets/icons/highSchool/English_4.svg")}`;
            break;
          case 9:
            element['icon']=`${require("../../assets/icons/highSchool/Government_economy.svg")}`;
            break;
          case 10:
            element['icon']=`${require("../../assets/icons/highSchool/algebra_1.svg")}`;
            break;
          case 11:
            element['icon']=`${require("../../assets/icons/highSchool/algebra_2.svg")}`;
            break;
          case 12:
            element['icon']=`${require("../../assets/icons/highSchool/Calculus.svg")}`;
            break;
          case 13:
            element['icon']=`${require("../../assets/icons/highSchool/Diferential_calculus.svg")}`;
            break;
          case 14:
            element['icon']=`${require("../../assets/icons/highSchool/integral_calculus.svg")}`;
            break;
          case 15:
            element['icon']=`${require("../../assets/icons/highSchool/Mathematical_logic.svg")}`;
            break;
          case 16:
            element['icon']=`${require("../../assets/icons/highSchool/arithmetic.svg")}`;
            break;
          case 17:
            element['icon']=`${require("../../assets/icons/highSchool/Analytic_geometry.svg")}`;
            break;
          case 18:
            element['icon']=`${require("../../assets/icons/highSchool/Geometry.svg")}`;
            break;
          case 19:
            element['icon']=`${require("../../assets/icons/highSchool/Trigonometry.svg")}`;
            break;
          default:
            break;
        }
      }
    }
  },
  methods: {
    toSubject(subject) {
      this.$store.commit('subject/SET_CURRENT_SUBJECT', subject);
      this.$activity.$emit('create-subject-activity', subject.id);

      // this.fetchClusters({ subject_path: subject.path, user_id: this.userAuthenticated.id }).then(
      //   res => {
      //     this.$store.commit('cluster/SET_CURRENT_CLUSTER', 0);
      //     this.$router.push(
      //       '/home/level/' +
      //         this.$route.params.level +
      //         '/grade/' +
      //         this.$route.params.grade +
      //         '/subject/' +
      //         subject.path +
      //         '/cluster/' +
      //         res.data[0].path,
      //     );
      //   },
      // );
    },
    onFetchSubjects() {
      let gradeId = this.$route.params.grade_id;
      this.level = this.$route.params.level;
      this.$store.commit('SET_CURRENT_LEVEL', this.level);
      this.fetchSubjects({ grade_id: gradeId });
    },
    ...mapActions({
      fetchSubjects: 'subject/FETCH_LIST',
      // fetchClusters: 'cluster/FETCH_LIST',
    }),
    setPrincipalClass(){
      if(this.currentLevel<=3){
        console.log('poedimos');
        return 'subjects'
      }else{
        return 'new-class'
      }
    },
    getPercent(complete, total){
      let percent;
      percent= (complete*100)/total
      //return 40+'%';
      return percent.toFixed(2)+'%';
    },
  },
};
</script>
<style lang="scss" scope>
$square-size : 17vw;
$max-square: 400px;
$border-radius: 40px;

.subjects {
 font-family: "Futura", Helvetica, Arial;
 .row-subject {
  display: grid;
  grid-template-columns: 90%;
  justify-content: center;
 }
 .description{
  display: flex;
  align-items: flex-start;
  h1{
    font-size: 1.2rem;
    font-family: "FuturaBold", Helvetica, Arial;
    margin-bottom: unset;
  }
  div {
    width: 3px;
    height: 80%;
    background-color: #3960a5;
    margin-right: 10px;
  }
 }
  max-width: 1600px;
  margin-left: auto;
  margin-right: auto;
  &__subject {
    position: relative;
    width: $square-size;
    height: $square-size;
    min-width: 220px;
    min-height: 220px;
    background: white;
    border-radius: $border-radius;
    box-shadow: 5px 5px 10px rgba($color: #000000, $alpha: 0.4);
    line-height: 1.3;
    //height: calc(100%);
    display: grid;
    grid-template-rows: 50% 50%;
    gap: 5px;
    margin: 0 auto;
    text-decoration: none !important;
    margin-bottom: 30px;
    &:hover {
      cursor: pointer;
      box-shadow: 5px 5px 10px rgba($color: #000000, $alpha: 0.8);
      transition: margin 0.1s, box-shadow 0.1s;
      transition-timing-function: ease-out;
    }
    &__icon {
      position: relative;
      text-align: center;
        .subject-logo {
          padding-top: 1rem;
          width: 40%;
          @media all and (min-width: 1224px){
            width: 45%;
          }
           @media all and (min-width: 1424px){
            padding-top: 3rem;
          }
        }
    }
    &__body {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      text-decoration: none;
      color: #3960a5;
      .lesson-title {
        text-transform: uppercase;
        text-align: center;
        font-size: 0.8rem;
        font-family: "FuturaBold", Helvetica, Arial;
        @media all and (min-width: 1224px){
            font-size: 1.2rem;
          }
      }
      .progress {
        position: relative;
        height: 1.5rem;
        border-radius: 50px;
        margin: 0.5rem 1rem;
        overflow: hidden;
        .progress-bar {
          //position: absolute;
          background-color: rgb(222, 100, 51);
          width: 100%;
        }
        .progress-leyend {
          position: absolute;
          top: 50%;
          right: 0.8rem;
          font-weight: bolder;
          font-size: 14px;
          font-family: "FuturaBold", Helvetica, Arial;
        }
         .start{
          position: relative;
          img {
            position: absolute;
            width: 1.8rem;
            top: -0.2rem;
            left: -1rem;
          }
        }
      }
      .lesson-progress {
        text-align: center;
        padding-bottom: 0.8rem;
        font-size: 0.7rem;
        @media all and (min-width: 1224px){
          font-size: 0.8rem;
        }
      }
    }
  }
  @media all and (min-height: 1024px){
    height: 90vh;
    display: flex;
    justify-content: center;
    align-items: stretch;
    flex-direction: column;;
  }
  @media (min-width: 661px) and (max-width: 900px) {
    .row-subject {
      grid-template-columns: 50% 50%;
    }
  }
  @media (min-width: 901px) and (max-width: 1920px){
    .row-subject {
      grid-template-columns: 33% 33% 33%;
    }
  }
  @media all and (min-width: 1921px){
    .row-subject {
      grid-template-columns: 33% 33% 33%;
    }
    &__subject {
        max-width: 400px;
        max-height: 400px;
         &__icon {
            .subject-logo {
              padding-top: 2.5rem;
              width: 50%;
            }
        }
        &__body{
          .lesson-title{
            font-size: 1.8rem;
          }
        }
    }
  }
}
.first-level {
 font-family: "Futura", Helvetica, Arial;
 .row-subject {
  display: grid;
  grid-template-columns: 90%;
  justify-content: center;
 }
 .description{
  display: flex;
  align-items: flex-start;
  h1{
    font-size: 1.2rem;
    font-family: "FuturaBold", Helvetica, Arial;
  }
  div {
    width: 3px;
    height: 80%;
    background-color: #3960a5;
    margin-right: 10px;
  }
 }
  max-width: 1600px;
  margin-left: auto;
  margin-right: auto;
  &__subject {
    position: relative;
    width: $square-size;
    height: $square-size;
    min-width: 230px;
    min-height: 230px;
    background: white;
    border-radius: $border-radius;
    box-shadow: 5px 5px 10px rgba($color: #000000, $alpha: 0.4);
    line-height: 1.3;
    //height: calc(100%);
    display: grid;
    grid-template-rows: 50% 50%;
    gap: 5px;
    margin: 0 auto;
    text-decoration: none !important;
    margin-bottom: 10px;
    &:hover {
      cursor: pointer;
      box-shadow: 5px 5px 10px rgba($color: #000000, $alpha: 0.8);
      transition: margin 0.1s, box-shadow 0.1s;
      transition-timing-function: ease-out;
    }
    &__icon {
      position: relative;
      text-align: center;
        .subject-logo {
          padding-top: 0.5rem;
          width: 45%;
        }
    }
    &__body {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      text-decoration: none;
      color: #3960a5;
      .lesson-title {
        text-transform: uppercase;
        text-align: center;
        font-size: 1.2rem;
        font-family: "FuturaBold", Helvetica, Arial;
      }
      .progress {
        position: relative;
        height: 1.5rem;
        border-radius: 50px;
        margin: 1rem 1rem;
        overflow: unset;
        .progress-bar {
          //position: absolute;
          background-color: #E84855;
          width: 100%;
          border-bottom-left-radius: 50px;
          border-top-left-radius: 50px;
        }
        .progress-leyend {
          position: absolute;
          top: 50%;
          right: 0.8rem;
          font-weight: bolder;
          font-size: 14px;
          font-family: "FuturaBold", Helvetica, Arial;
        }
        .start{
          position: relative;
          img {
            position: absolute;
            width: 2.5rem;
            top: -0.5rem;
            left: -1rem;
          }
        }
      }
      .lesson-progress {
        text-align: center;
        padding-bottom: 0.8rem;
        font-size: 0.8rem;
      }
    }
  }
  @media  all and (min-width: 1100px) and (orientation : landscape) {
     height: 90vh;
    display: flex;
    justify-content: center;
    align-items: stretch;
    flex-direction: column;;
  }
  @media all and (min-height: 800px){
    height: 90vh;
    display: flex;
    justify-content: center;
    align-items: stretch;
    flex-direction: column;;
  }
  @media (min-width: 661px) and (max-width: 900px) {
    .row-subject {
      grid-template-columns: 50% 50%;
    }
  }
  @media (min-width: 901px) and (max-width: 1920px){
    .row-subject {
        grid-template-columns: repeat(4, 1fr);
    }
  }
  @media all and (min-width: 1921px){
    .row-subject {
       grid-template-columns: repeat(4, 1fr);
       grid-gap: 20px;
    }
    &__subject {
       &__icon {
     // position: relative;
      //text-align: center;
        .subject-logo {
          width: 50%;
        }
    }
     &__body {
      .lesson-title {
        font-size: 1.8rem;
      }
      .progress {
        position: relative;
        height: 2.5rem;
        border-radius: 50px;
        margin: 1.5rem 1rem;
        overflow: unset;
        .progress-bar {
          //position: absolute;
          background-color: #E84855;
          width: 100%;
          border-bottom-left-radius: 50px;
          border-top-left-radius: 50px;
        }
        .progress-leyend {
          position: absolute;
          top: 50%;
          right: 0.8rem;
          font-weight: bolder;
          font-size: 1.5rem;
          font-family: "FuturaBold", Helvetica, Arial;
        }
        .start{
          position: relative;
          img {
            position: absolute;
            width: 4.5rem;
            top: -1.3rem;
            left: -1rem;
          }
        }
      }
      .lesson-progress {
        text-align: center;
        padding-bottom: 0.8rem;
        font-size: 1rem;
      }
     }
    }
  }
}
.first-level-1-2 {
 font-family: "Futura", Helvetica, Arial;
 .row-subject {
  display: grid;
  grid-template-columns: 90%;
  justify-content: center;
 }
 .description{
  display: flex;
  align-items: flex-start;
  h1{
    font-size: 1.2rem;
    font-family: "FuturaBold", Helvetica, Arial;
    margin-bottom: unset;
  }
  div {
    width: 3px;
    height: 80%;
    background-color: #3960a5;
    margin-right: 10px;
  }
 }
  max-width: 1600px;
  margin-left: auto;
  margin-right: auto;
  &__subject {
    position: relative;
    width: $square-size;
    height: $square-size;
    min-width: 200px;
    min-height: 200px;
    background: white;
    border-radius: $border-radius;
    box-shadow: 5px 5px 10px rgba($color: #000000, $alpha: 0.4);
    line-height: 1.3;
    //height: calc(100%);
    display: grid;
    grid-template-rows: 50% 50%;
    gap: 5px;
    margin: 0 auto;
    text-decoration: none !important;
    margin-bottom: 30px;
    &:hover {
      cursor: pointer;
      box-shadow: 5px 5px 10px rgba($color: #000000, $alpha: 0.8);
      transition: margin 0.1s, box-shadow 0.1s;
      transition-timing-function: ease-out;
    }
   &__icon {
      position: relative;
      text-align: center;
        .subject-logo {
          padding-top: 0.5rem;
          width: 35%;
          @media all and (min-width: 1224px){
            width: 45%;
          }
          @media all and (min-width: 1424px){
            padding-top: 3rem;
          }
        }
    }
    &__body {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      text-decoration: none;
      color: #3960a5;
      .lesson-title {
        text-transform: uppercase;
        text-align: center;
        font-size: 0.8rem;
        font-family: "FuturaBold", Helvetica, Arial;
         @media all and (min-width: 1224px){
             font-size: 1.2rem;
          }
      }
      .progress {
        position: relative;
        height: 1.5rem;
        border-radius: 50px;
        margin: 1rem 1rem;
        overflow: unset;
        .progress-bar {
          //position: absolute;
          background-color: #E84855;
          width: 100%;
          border-bottom-left-radius: 50px;
          border-top-left-radius: 50px;
        }
        .progress-leyend {
          position: absolute;
          top: 50%;
          right: 0.8rem;
          font-weight: bolder;
          font-size: 14px;
          font-family: "FuturaBold", Helvetica, Arial;
        }
        .start{
          position: relative;
          img {
            position: absolute;
            width: 2.5rem;
            top: -0.5rem;
            left: -1rem;
          }
        }
      }
      .lesson-progress {
        text-align: center;
        padding-bottom: 0.8rem;
        font-size: 0.8rem;
      }
    }
  }
  @media  all and (min-width: 1300px) and (orientation : landscape) {
     height: 90vh;
    display: flex;
    justify-content: center;
    align-items: stretch;
    flex-direction: column;;
  }
  @media all and (min-height: 800px){
    height: 90vh;
    display: flex;
    justify-content: center;
    align-items: stretch;
    flex-direction: column;;
  }
  @media (min-width: 661px) and (max-width: 900px) {
    .row-subject {
      grid-template-columns: 50% 50%;
    }
  }
  @media (min-width: 901px) and (max-width: 1920px){
    .row-subject {
        grid-template-columns: repeat(3, 1fr);
    }
  }
  @media all and (min-width: 1921px){
    .row-subject {
       grid-template-columns: repeat(3, 1fr);
       grid-gap: 20px;
    }
    &__subject {
      &__icon {
        .subject-logo {
          padding-top: 1.5rem;
          width: 50%;
        }
    }
     &__body {
      .lesson-title {
        font-size: 1.8rem;
      }
      .progress {
        position: relative;
        height: 2.5rem;
        border-radius: 50px;
        margin: 1.5rem 1rem;
        overflow: unset;
        .progress-bar {
          //position: absolute;
          background-color: #E84855;
          width: 100%;
          border-bottom-left-radius: 50px;
          border-top-left-radius: 50px;
        }
        .progress-leyend {
          position: absolute;
          top: 50%;
          right: 0.8rem;
          font-weight: bolder;
          font-size: 1.5rem;
          font-family: "FuturaBold", Helvetica, Arial;
        }
        .start{
          position: relative;
          img {
            position: absolute;
            width: 4.5rem;
            top: -1.3rem;
            left: -1rem;
          }
        }
      }
      .lesson-progress {
        text-align: center;
        padding-bottom: 0.8rem;
        font-size: 1rem;
      }
     }
    }
  }
}
.fourth-level {
 font-family: "Futura", Helvetica, Arial;
 .row-subject {
  display: grid;
  grid-template-columns: 90%;
  justify-content: center;
 }
 .description{
  display: flex;
  align-items: flex-start;
  h1{
    font-size: 1.2rem;
    font-family: "FuturaBold", Helvetica, Arial;
    margin-bottom: unset;
  }
  div {
    width: 3px;
    height: 80%;
    background-color: #3960a5;
    margin-right: 10px;
  }
 }
  max-width: 1600px;
  margin-left: auto;
  margin-right: auto;
  &__subject {
    position: relative;
    width: $square-size;
    height: $square-size;
    min-width: 230px;
    min-height: 230px;
    background: white;
    border-radius: 20px;
    box-shadow: 5px 5px 10px rgba($color: #000000, $alpha: 0.4);
    line-height: 1.3;
    display: grid;
    grid-template-rows: 100% ;
    gap: 5px;
    margin: 0 auto;
    text-decoration: none !important;
    margin-bottom: 30px;
    &:hover {
      cursor: pointer;
      box-shadow: 5px 5px 10px rgba($color: #000000, $alpha: 0.8);
      transition: margin 0.1s, box-shadow 0.1s;
      transition-timing-function: ease-out;
    }  
    &__body {
      position: relative;
      display: grid;
      grid-template-rows: 1fr 3fr 0.5fr 0.5fr;
      grid-gap: 10px;
      background: white;
      border-top-left-radius: 50px;
      border-top-right-radius: 50px;
      .lesson-title {
        padding-top: 0.5rem;
        text-transform: uppercase;
        text-align: center;
        font-size: 1.5rem;
        font-family: "FuturaBold", Helvetica, Arial;
      }
      .icon {
        position: relative;
        width: 100%;
        text-align: center;
        .subject-logo {
          width: 70%
        }
      }
      .lesson-progress {
        text-align: center;
        font-size: 0.7rem;
      }
      .progress {
        position: absolute;
        bottom: -3px;
        left: -8px;
        width: 105%;
        height: 1.5rem;
        border-radius: 50px;
        .progress-bar {
         background-color: transparent;
          width: 100%;
        }
        .progress-leyend {
          position: absolute;
          top: 50%;
          right: 0.8rem;
          font-weight: bolder;
          font-size: 14px;
          font-family: "FuturaBold", Helvetica, Arial;
        }
         .start{
          position: relative;
          img {
            position: absolute;
            width: 1.6rem;
            top: 0;
            left: 0rem;
          }
        }
      }
    }
  }
  @media all and (min-height: 2100px){
    height: 90vh;
    display: flex;
    justify-content: center;
    align-items: stretch;
    flex-direction: column;;
  }
  @media (min-width: 661px) and (max-width: 900px) {
    .row-subject {
      grid-template-columns: repeat(2, 1fr)
    }
  }
  @media (min-width: 901px) and (max-width: 1920px){
    .row-subject {
      grid-template-columns: repeat(4, 1fr);
      grid-gap: 5px;
    }
    &__subject {
      &__body {
        .lesson-progress {
          font-size: 0.9rem;
          width: 100%;
          position: absolute;
          bottom: 2rem;
        }
      }
    }
  }
  @media all and (min-width: 1921px){
    .row-subject {
      grid-template-columns: repeat(5, 1fr);
      grid-gap: 20px;
    }
      &__subject {
        max-width: 400px;
        max-height: 400px;
      &__body {
        .progress{
          left: -16px;
          height: 2.5rem;
          .progress-leyend{
            font-size: 1.2rem;
          }
          .start {
            img{
              width: 2.5rem;
            }
          }
        }
        .lesson-title{
          font-size: 2rem;
          padding-top: 2rem;
        }
        .lesson-progress {
          font-size: 1rem;
          width: 100%;
          position: absolute;
          bottom: 3rem;
        }
      }
    }
  }
}

::-webkit-scrollbar {
  background: rgba($color: #ebebeb, $alpha: 0.4);
  border-radius: 0 0 10px 10px;
  width: 8px;
}

::-webkit-scrollbar-thumb {
  background: #aeaeae;
  border-radius: 0 0 10px 10px;
}
</style>
